import _implicitStylesheets from "./modal.css";
import _implicitScopedStylesheets from "./modal.scoped.css?scoped=true";
import _axIconInteractive from "ax/iconInteractive";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="backdrop${0}"${2}></div>`;
const $fragment2 = parseFragment`<h3 type-style="body-1"${3}>${"t1"}</h3>`;
const $fragment3 = parseFragment`<div class="divider${0}"${2}></div>`;
const stc0 = {
  "modal-wrapper": true
};
const stc1 = {
  classMap: {
    "modal": true
  },
  key: 3
};
const stc2 = {
  classMap: {
    "content": true
  },
  key: 4
};
const stc3 = {
  "modal-header": true
};
const stc4 = {
  "close-button": true
};
const stc5 = {
  classMap: {
    "modal-body": true
  },
  attrs: {
    "grid": "",
    "axis": "column",
    "row-gap": "large"
  },
  key: 11
};
const stc6 = {
  attrs: {
    "name": "main-content"
  },
  key: 12
};
const stc7 = [];
const stc8 = {
  classMap: {
    "modal-footer": true
  },
  key: 13
};
const stc9 = {
  attrs: {
    "name": "footer"
  },
  key: 14
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, b: api_bind, sp: api_static_part, st: api_static_fragment, d: api_dynamic_text, c: api_custom_element, h: api_element, s: api_slot} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "role": "dialog",
      "aria-labelledby": api_scoped_id("modal-header")
    },
    key: 0,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleInputKey))
    }
  }, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.closeModal))
    }
  }, null)]), api_element("div", stc1, [api_element("div", stc2, [api_element("div", {
    classMap: stc3,
    attrs: {
      "id": api_scoped_id("modal-header")
    },
    key: 5
  }, [api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text($cmp.title))]), api_custom_element("ax-icon-interactive", _axIconInteractive, {
    classMap: stc4,
    props: {
      "iconDescription": $cmp.closeIconDescription,
      "icon": "close",
      "transparentBackground": true,
      "ariaHidden": true
    },
    key: 8,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.closeModal))
    }
  })]), api_static_fragment($fragment3, 10), api_element("div", stc5, [api_slot("main-content", stc6, stc7, $slotset)]), api_element("div", stc8, [api_slot("footer", stc9, stc7, $slotset)])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["footer", "main-content"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2j98keitvde";
tmpl.legacyStylesheetToken = "undefined-_modal";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
